// extracted by mini-css-extract-plugin
module.exports = {"wrapContent":"search-project_wrapContent_2fNYL","label":"search-project_label_4rQ70","searchInput":"search-project_searchInput_2NzY9"};